import { ComponentType } from 'react';
import { Card, CardDescription, CardHeader, CardTitle } from 'components/ui/card';

interface ProjectCardProps {
  title: string;
  description: string;
  url: string;
  icon: ComponentType<{ className?: string }>;
  onClick?: () => void;
}

export const ProjectCard = ({ title, description, url, icon: Icon, onClick }: ProjectCardProps) => {
  return (
    <a href={url} target="_blank" referrerPolicy="no-referrer" onClick={onClick}>
      <Card className="h-full cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
        <CardHeader className="p-3 sm:p-4">
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-lg bg-[hsl(var(--accent))] text-[var(--text-primary)] sm:mb-4 sm:h-12 sm:w-12">
            <Icon className="h-5 w-5 sm:h-6 sm:w-6" />
          </div>
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
      </Card>
    </a>
  );
};
